export default __webpack_public_path__ + "static/media/Facebook.ccc0f024.svg";